import React, { Fragment } from "react";
import PropTypes from "prop-types";
import CheckBoxWithChild from "../../../common/CheckBoxWithChild";
import { Popup } from 'semantic-ui-react';
import Row from "../../../common/Row";

const SporttakkenComponent = (props) => {
    const {
        sporttakken,
        checkedSporttakken,
        onChange,
        parentLevel,
        onIncreaseLevel,
        disableChecked,
        disabledSporttakken,
        indeterminateSporttakken,
        maxLevel,
        disabled,
        hideCheckbox,
        showAllSubsporttakken,
        hasDeleteOption,
        onDelete,
        disableDelete
    } = props;

    function mapOnDelete(id) {
        return function (event) {
            onDelete(id, event);
        };
    }

    const newLevel = parentLevel + 1;

    const emptyLeadingCells = (newLevel) => {
        let emptyTDs = [];
        for (let i = 0; i < (newLevel); i++) {
            emptyTDs.push(<td style={{ 'border': '1px', 'borderStyle': 'solid', 'borderColor': '#eeefef' }}></td>);
        }

        return emptyTDs;
    };

    const emptyTrailingCells = (newLevel) => {
        let emptyTDs = [];
        for (let i = newLevel; i <= (maxLevel); i++) {
            emptyTDs.push(<td style={{ 'border': '1px', 'borderStyle': 'solid', 'borderColor': '#eeefef' }}></td>);
        }

        return emptyTDs;
    };

    const isChecked = (id) => {
        return checkedSporttakken ? checkedSporttakken.indexOf(id) > -1 : null;
    };
    const isDisabled = (id) => {
        return disableChecked && disabledSporttakken ? disabledSporttakken.indexOf(id) > -1 : null;
    };

    function returnTdContent(text) {
        const checkLength = 20;
        return text.length > checkLength ? <Popup wide="very" position="top left" trigger={<p>{text.substring(0, checkLength) + "..."}</p>} content={text} /> : text;
    }

    const sporttakkenColumn = sporttakken.map((sporttak, i) => {
        onIncreaseLevel(parentLevel);
        const subsporttakken = showAllSubsporttakken ? sporttak.subsporttakken : sporttak.subsporttakken.filter(s => checkedSporttakken.indexOf(s.id) > -1);
        return (
            <Fragment key={newLevel + "_" + i}>
                <tr key={newLevel * i} style={{ 'border': '1px', 'borderStyle': 'none', 'borderColor': '#eeefef', 'height': '10px' }}>
                    {emptyLeadingCells(newLevel - 1)}
                    <td style={{ 'border': '1px', 'borderStyle': 'solid', 'borderColor': '#eeefef', 'paddingBottom': '2px', 'paddingTop': '2px', 'paddingLeft': '2px', 'paddingRight': '5px' }}>
                        {hideCheckbox ?
                            hasDeleteOption ?
                                 <Row><p className="o-col-10">{returnTdContent(sporttak.naam)}</p><span className="o-col-2" onClick={disableDelete ? null : mapOnDelete(sporttak.id)} style={{ color: disableDelete ? '#eeefef' : '#777', fontSize: '1rem', cursor: disableDelete ? 'not-allowed' : 'pointer' }}><i className="fa fa-remove fa-fw"></i></span></Row>
                                :
                                <p>{returnTdContent(sporttak.naam)}</p>
                            :
                            <CheckBoxWithChild
                                key={sporttak.id}
                                name={sporttak.id + '_' + sporttak.moederId}
                                value={isChecked(sporttak.id)}
                                label={returnTdContent(sporttak.naam)}
                                onChange={onChange}
                                disabled={isDisabled(sporttak.id) || disabled}
                            />
                        }
                    </td>
                    {emptyTrailingCells(newLevel)}
                </tr>
                {(subsporttakken && subsporttakken.length) ?
                    <SporttakkenComponent
                        sporttakken={subsporttakken}
                        onChange={onChange}
                        parentLevel={newLevel}
                        checkedSporttakken={checkedSporttakken}
                        onIncreaseLevel={onIncreaseLevel}
                        disableChecked={disableChecked}
                        disabledSporttakken={disabledSporttakken}
                        indeterminateSporttakken={indeterminateSporttakken}
                        maxLevel={maxLevel}
                        disabled={disabled}
                        hideCheckbox={hideCheckbox}
                        showAllSubsporttakken={showAllSubsporttakken}
                        hasDeleteOption={hasDeleteOption}
                        onDelete={onDelete}
                        disableDelete={disableDelete}
                    />
                    : null}
            </Fragment>
        );
    });

    return (
        sporttakkenColumn
    );
};

SporttakkenComponent.defaultProps = {
    parentLevel: 0,
    disableChecked: false
};

SporttakkenComponent.propTypes = {
    sporttakken: PropTypes.array,
    onChange: PropTypes.func,
    checkedSporttakken: PropTypes.array,
    onIncreaseLevel: PropTypes.func,
    parentLevel: PropTypes.number,
    disableChecked: PropTypes.bool,
    disabledSporttakken: PropTypes.array,
    indeterminatedSporttakken: PropTypes.array,
    disabled: PropTypes.bool,
    showAllSubsporttakken: PropTypes.bool,
    onDelete: PropTypes.func,
    disableDelete: PropTypes.bool
};

export default SporttakkenComponent;